import { useEffect, useRef } from 'react'
import Dialog from '../../../control/dialog/dialog'
import useTranslate from '../../../i18n/useTranslate'
import Content from './Content'

interface AcceptanceProps {
    isOpen: boolean
    onClickAccept: () => void
    onClickClose: () => void
}
const Acceptance = ({ isOpen, onClickAccept, onClickClose }: AcceptanceProps) => {
    const translate = useTranslate()
    const dialogAcceptance = useRef<Record<string, Function>>()

    const onRefDialogAcceptance = (func: Record<string, Function>) => {
        dialogAcceptance.current = func
    }

    useEffect(() => {
        if (isOpen) dialogAcceptance.current?.openDialog()
        else dialogAcceptance.current?.closeDialog()
    }, [isOpen])

    return (
        <>
            <Dialog
                onRef={onRefDialogAcceptance}
                type="dialog-element-accept"
                title={translate.get('UM.EXTERNAL-REGISTER.ACCEPTANCE')}
                content={<Content lang={translate.languageStore.currentLanguage} />}
                onClickConfirm={onClickAccept}
                onAfterClose={onClickClose}
                reachedBottom={true}
            />
        </>
    )
}

export default Acceptance
